const throwReactQueryError = (error) => {
  throw {
    ...error?.response?.data?.error,
    metadata: {
      code: error?.response?.status || 'NO_CODE',
      status: error?.response?.statusText || 'NOT_IMPLEMENTED'
    }
  }
}

export default throwReactQueryError
